/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import { Icon } from 'fpay-ui';

import { REGIONS } from '@constants/regions';
import * as DOCUMENT_STATUS from '@constants/documentation';
import {
  downloadFile,
  getFormatedDate,
  getClassDocumentation,
  getTextDocumentation,
  getDocSubtitle,
} from '@helpers/utils';
import AnalyticsDiv from '@components/AnalyticsDiv';
import Dropzone from '@components/dropzone/Dropzone';
import { useDocument } from '@hooks/useDocument';
import { useAuth } from '@hooks';

import './styless.css';
import { getEnv } from '@config';

const { country, publicPath } = getEnv();

export default function ({ data, handleFilesUploaded, index, onClick, id }) {
  const { isAllowed } = useAuth();
  const { downloadDocument } = useDocument();

  const [open, setOpen] = useState(false);

  const { t } = useTranslation();
  useEffect(() => {
    setOpen(false);
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleRowClick = () => {
    // data.status = DOCUMENT_STATUS.PENDING;
    if (
      data.status === DOCUMENT_STATUS.WITHOUT_SUBMITTING ||
      data.status === DOCUMENT_STATUS.REJECTED
    ) {
      setOpen(!open);
    }
  };

  const handleDownload = async () => {
    const { file } = await downloadDocument(data.type);
    downloadFile(data.file, file);
  };

  const { tag } = DOCUMENT_STATUS.getDocObject(data.type);
  return (
    <div key={index}>
      {data && (
        <Card className="documentRow" id={`document-row-${id}`}>
          <AnalyticsDiv tag={`show${tag}`}>
            <Grid container justify="space-between" alignItems="center">
              <Grid item className="justLarge">
                <h6 id="text-document">{DOCUMENT_STATUS.getDocObject(data.type).title}</h6>
              </Grid>

              <Grid item container justify="space-between" className="noLarge">
                <Grid item container direction="row" justify="space-between" wrap="nowrap">
                  <h6 id="text-document">{DOCUMENT_STATUS.getDocObject(data.type).title}</h6>
                  <Grid
                    item
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="flex-start"
                    wrap="nowrap"
                    style={{ width: '54px', marginBottom: '12px' }}
                  >
                    {isAllowed('DOCUMENT_DOWNLOAD') &&
                      (data.status === DOCUMENT_STATUS.APROVED ||
                        DOCUMENT_STATUS.REJECTED === data.status) && (
                        <span
                          data-testid={`document-btn-download-${id}`}
                          style={{ cursor: 'pointer' }}
                          onClick={handleDownload}
                        >
                          <Icon icon="ic-download" />
                        </span>
                      )}

                    {DOCUMENT_STATUS.WITHOUT_SUBMITTING === data.status ||
                    DOCUMENT_STATUS.REJECTED === data.status ? (
                      <img
                        alt="toparrow"
                        data-testid={`document-btn-upload-${id}`}
                        style={{ width: '24px', cursor: 'pointer' }}
                        onClick={handleRowClick}
                        src={`${publicPath}/topArrow.svg`}
                      />
                    ) : (
                      ''
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item className="justLarge">
                <Grid container spacing={2}>
                  {DOCUMENT_STATUS.PENDING === data.status ||
                  DOCUMENT_STATUS.APROVED === data.status ? (
                    <Grid item>
                      <span data-testid={`document-row-${index}-date`} className="date">
                        {t('documentation.presented')}
                      </span>
                      {getFormatedDate(data.updated_at, REGIONS[country].dateFormat)}
                    </Grid>
                  ) : (
                    ''
                  )}
                  <Grid item>
                    <span
                      data-testid={`document-row-${index}-status`}
                      className={getClassDocumentation(data.status)}
                    >
                      {getTextDocumentation(data.status)}
                    </span>
                  </Grid>
                  <Grid
                    container
                    direction="row"
                    justify="space-between"
                    wrap="nowrap"
                    style={{ width: '54px' }}
                  >
                    {isAllowed('DOCUMENT_DOWNLOAD') &&
                      (data.status === DOCUMENT_STATUS.APROVED ||
                        DOCUMENT_STATUS.REJECTED === data.status) && (
                        <span
                          data-testid={`document-btn-download-${id}`}
                          style={{ cursor: 'pointer' }}
                          onClick={handleDownload}
                        >
                          <Icon icon="ic-download" />
                        </span>
                      )}
                    {DOCUMENT_STATUS.WITHOUT_SUBMITTING === data.status ||
                    DOCUMENT_STATUS.REJECTED === data.status ? (
                      <img
                        data-testid={`document-btn-upload-${id}`}
                        src={`${publicPath}/topArrow.svg`}
                        alt="Logo de guardar"
                        onClick={handleRowClick}
                        style={{ cursor: 'pointer' }}
                        width="24px"
                        height="24px"
                      />
                    ) : (
                      ''
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </AnalyticsDiv>
          {getDocSubtitle(DOCUMENT_STATUS.getDocObject(data.type, 'docSubtitle'))}

          {DOCUMENT_STATUS.REJECTED === data.status && (
            <Grid container className="justLarge statusContainer">
              <Grid item className="rejected">
                <span data-testid={`document-row-${index}-comment`}>
                  {data.comments || t('documentation.rejectedHelperText')}
                </span>
              </Grid>
            </Grid>
          )}

          <Grid container className="noLarge statusContainer" spacing={1}>
            {DOCUMENT_STATUS.PENDING === data.status || DOCUMENT_STATUS.APROVED === data.status ? (
              <Grid item xs={12} className="docDate">
                <span data-testid={`document-row-${index}-date`} className="date">
                  {t('documentation.presented')}
                  {getFormatedDate(data.updated_at, REGIONS[country].dateFormat)}
                </span>
              </Grid>
            ) : (
              DOCUMENT_STATUS.REJECTED === data.status && (
                <Grid item className="rejected">
                  <span data-testid={`document-row-${index}-comment`}>
                    {data.comments || t('documentation.rejectedHelperText')}
                  </span>
                </Grid>
              )
            )}
            <Grid item>
              <span
                data-testid={`document-row-${index}-status`}
                className={getClassDocumentation(data.status)}
              >
                {getTextDocumentation(data.status)}
              </span>
            </Grid>
          </Grid>
          {open && (
            <Grid container justify="center">
              <Grid item xs={12} md={8} lg={6} container justify="center">
                <Dropzone
                  id="dropzone"
                  key={index}
                  handleFilesUploaded={handleFilesUploaded(id)}
                  onSubirClick={(e) => {
                    onClick(e, id);
                    setOpen(false);
                  }}
                  tagAdd={`select${tag}`}
                  tagUpload={`upload${tag}`}
                  // filesLimit={
                  //   data.type === "pjt6" || data.type === "pjd6" ? 3 : undefined
                  // }
                  idSubir={id || 1}
                />
              </Grid>
            </Grid>
          )}
        </Card>
      )}
    </div>
  );
}
